import { render, staticRenderFns } from "./PublicationsEdit.vue?vue&type=template&id=af1587fc&scoped=true&"
import script from "./PublicationsEdit.vue?vue&type=script&lang=js&"
export * from "./PublicationsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1587fc",
  null
  
)

export default component.exports